import { TextField } from "@goodgamestudios/createjs-utilities";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../../model/Poker2Model";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserTextsVO } from "./common/TeaserTextsVO";
import { TeaserVO } from "./common/TeaserVO";

import MovieClip = createjs.MovieClip;

export class Tables50BBTeaser extends AbstractTeaser {
    private _txtTitle: TextField;
    private _btnOk: MovieClip;
    private _tf_xp: TextField;
    private _tf_table: TextField;
    private _tf_tableType: TextField;
    private _tf_lobby: TextField;
    private _tf_50bb: TextField;

    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super(featureId, teaserMc, teaserVO);
    }

    protected buildHook(): void {
        this._txtTitle = this._teaserMc.txt_title;
        this._btnOk = this._teaserMc.btn_ok;

        this._teaserMc.content.mouseChildren = false;
        this._tf_lobby = this._teaserMc.content.tf_lobby;
        this._tf_tableType = this._teaserMc.content.tf_tableType;
        this._tf_50bb = this._teaserMc.content.tf_50bb;
        this._tf_table = this._teaserMc.content.tf_table;
        this._tf_xp = this._teaserMc.content.tf_xp;
    }

    public fillTexts(vo: TeaserTextsVO): void {
        super.fillTexts(vo);

        this._txtTitle.text = vo.titleStr;

        //
        this._tf_lobby.text = Poker2Model.languageData.getTextById("lobby_title");
        this._tf_tableType.text = Poker2Model.languageData.getTextById("lobby_tableTyp");
        this._tf_50bb.text = Poker2Model.languageData.getTextById("lobby_combo_tableTyp_2");
        this._tf_table.text = Poker2Model.languageData.getTextById("lobby_tables");
        this._tf_xp.text = Poker2Model.languageData.getTextById("dialog_ranking_xp");
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        var textVO: TeaserTextsVO = (vo == null) ? this._teaserVO.teaserTextsVO : vo;

        this._btnOk.label = textVO.btnOkLabel;
    }
}
classImplementsInterfaces(Tables50BBTeaser, "Container");
